<template>
  <div class="map_container">
    <div id="myMap" ref="panoContainer">
    </div>
    <div :class="['map_container__map_content', showMiniMap ? 'mini-map' : '']">
      <GmapMap 
        :center="center" 
        :zoom="zoom" 
        :class="loadingMap ? 'hidden' : ''"
        style="width: 100%; height: 100%" 
        ref="map"
        @click="windowClicked">
        <gmap-info-window
          :options="infoWindowOptions"
          :position="infoWindowPosition"
          :opened="infoWindowOpen"
          @closeclick="closeWindow()"
        >
        </gmap-info-window>
        <template v-if="!showMiniMap">
          <gmap-polyline 
            v-for="street in listStreet" :key="street.id"
            :path="transformAllCoordinate(street.coordinates)" 
            :editable="false" 
            :options="polyLineOpts"
            @click="showWindow(street.coordinates[0], street.reason, street.name, street.id)"
            ref="polyline">
          </gmap-polyline>
        </template>

        <!-- Billboard Marker -->
        <gmap-info-window
          :options="infoWindowBillboard"
          :position="infoWindowBillboardPosition"
          :opened="infoWindowBillboardOpen"
          @closeclick="closeWindowBillboard()"
        >
        </gmap-info-window>
        <template v-if="!showMiniMap">
          <gmap-marker 
            :key="m.id + 'marker'" v-for="m in markers" 
            :position="m.position"
            :clickable="true"
            :icon="getIcon(m.record)"
            :zIndex=1
            @click="toggleInfoWindowMarker(m, m.id)">
          </gmap-marker>

          <!-- marker icon verified -->
          <gmap-marker 
            :key="m.id + 'verified'" v-for="m in markers" 
            :position="m.position"
            :clickable="true"
            :icon="verifiedIcon"
            :zIndex=2
            :opacity="getVerifiedIcon(m.record)"
            @click="toggleInfoWindowMarker(m, m.id)">
          </gmap-marker>

          <!-- marker search coordinate -->
          <gmap-marker 
            :position="position"
            :clickable="false">
          </gmap-marker>
        </template>
      </GmapMap>
      <div :class="['map_loading', loadingMap ? 'flex' : 'hidden']">
        <adx-loading />
      </div>
      <info-window 
        ref="window" 
        @updateData="updateData" 
        :placements="placements" 
        @addToItems="updateItems($event)"
        @removeFromOrder="updateListOrder($event)"
        :listOrder="listOrder"
      />
    </div>
    <div :class="['map_container__map_nav', showMiniMap ? 'hidden' : '']">
      <div @click.stop="windowClicked" class="map_container__map_nav__content">
        <div v-if="toggleButton" class="map_container__map_nav__content__toggle">
            <button @click.stop="toggleSideMenu()" class="buttonMenu">
            <div class="menuBar"></div>
            <div class="menuBar"></div>
            <div class="menuBar"></div>
            </button>
        </div>
        <div v-if="toggleSide">
        <div class="map_container__map_nav__content__top">
          <div class="map_container__map_nav__content__top__brand" @click.stop="goToHome()">
            <img src="/img/adx/adx-red.png" alt="">
          </div>
          <div class="map_container__map_nav__content__top__icons">
            <i ref="btnClose" :class="['adx-ic_close', inputSearch.length > 0 ? 'visible': '']" @click.stop="clearSearch()"></i>
            <i class="adx-ic_search" @click.stop="toggleSearchBox()"></i>
            <div class="iconleft"><img  src="/img/ic-next@2x.png" alt="" @click.stop="toggleSideMenu()"></div>
            <!-- <i class="iconleft" @click.stop="toggleSideMenu()">&#10094;&#10094;</i> -->
          </div>
          
          <div ref="searchBox" class="map_container__map_nav__content__top__search_box">
            <input 
              type="text"
              name="search"
              id="search"
              class="search_input mini-font"
              v-model="inputSearch"
              placeholder="Search Code"
              ref="inputSearch"
              v-on:keyup.enter="searchCode">
          </div>
        </div>
        <div class="map_container__map_nav__content__mid">
          <div class="map_container__map_nav__content__mid__header">
            <span class="mini-font strong city_header">CITY</span>
            <span ref="selectedCity" class="mini-font">{{ selectedCity ? `View ${selectedCityDisplay}` : '' }}</span>
          </div>
          <div class="map_container__map_nav__content__mid__search_box">
            <input 
            v-model="searchCity" 
            type="text" 
            placeholder="Search City"
            class="mini-font">
            <i class="adx-ic_search"></i>
          </div>
          <div class="map_container__map_nav__content__mid__city">
            <ul id="cities" class="cities">
              <li v-for="city in filteredList" :key="city.id" @click="selectCity(city.id, city.name)">
                <div :class="['city', city.id == selectedCity ? 'active' : '']">
                  <a class="small-font city_name">{{ city.name }}</a>
                  <i class="adx-ic_check"></i>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="map_container__map_nav__content__bottom" @click.stop="toggleExpand('type')">
          <div class="map_container__map_nav__content__bottom__header">
            <div class="map_container__map_nav__content__bottom__header__left">
              <span class="mini-font strong type_header">MEDIA TYPE</span>
              <span class="mini-font" ref="totalSelectedType">
                {{ listCheckedType.length > 0 ? `${listCheckedType.length} selected` : '' }}
              </span>
            </div>
            <div class="map_container__map_nav__content__bottom__header__right">
              <i :class="[isShownType ? ' icon-chevronup' : 'icon-chevrondown']"></i>
            </div>
          </div>
          <div class="map_container__map_nav__content__bottom__types" v-if="isShownType">
            <div v-for="(media, index) in listType" :key="index" class="list_type" @click.stop="selectType(media.name)">
              <div class="left_section">
                <span :class="['checkbox', listCheckedType.includes(media.name) ? 'active' : '']">
                  <i class="adx-ic_check"></i>
                </span>
                <span class="small-font media_text">{{ media.name }}</span>
              </div>
              <span class="media_icon">
                <img :src="getIconMediaType(media.name)" />
              </span>
            </div>
          </div>
          <div class="map_container__map_nav__content__bottom__actions" v-if="isShownType">
            <span class="mini-font strong reset" @click.stop="clearFilter('type')">Reset</span>
            <span class="mini-font strong apply" @click.stop="applyFilter()">Apply</span>
          </div>
        </div>
        <div class="map_container__map_nav__content__price">
          <div class="map_container__map_nav__content__price__header" @click.stop="toggleExpand('price')">
            <div class="map_container__map_nav__content__price__header__left">
              <span class="mini-font strong price_header">PRICE PER M</span>
            </div>
            <div class="map_container__map_nav__content__price__header__right">
              <i :class="[isShownType ? ' icon-chevronup' : 'icon-chevrondown']"></i>
            </div>
          </div>
          <div class="map_container__map_nav__content__price__input" v-if="isShowPrice">
            <div class="map_container__map_nav__content__price__input__wrapper">
              <div class="min-price">
                <a-input
                  :label="`Minimun Price`"
                  :value.sync="minPrice"
                  :isNumberOnly="true"
                  :isThousandSeparator="true"
                />
              </div>
              <div class="max-price">
              <a-input
                  :label="`Maximum Price`"
                  :value.sync="maxPrice"
                  :isNumberOnly="true"
                  :isThousandSeparator="true"
                />
              </div>
            </div>
            <div v-if="showErrorMsg" class="map_container__map_nav__content__price__error-message">
              <span class="micro-font color-pink">* Maximum price can not lower than minimum price</span>
            </div>
          </div>
          <div class="map_container__map_nav__content__price__actions" v-if="isShowPrice">
            <span class="mini-font strong reset" @click.stop="clearFilter('price')">Reset</span>
            <span class="mini-font strong apply" @click.stop="applyFilterPrice()">Apply</span>
          </div>
        </div>

        <div class="map_container__map_nav__content__placement" @click.stop="toggleExpand('placement')">
          <div class="map_container__map_nav__content__placement__header">
            <div class="map_container__map_nav__content__placement__header__left">
              <span class="mini-font strong city_header">PLACEMENT</span>
              <span ref="selectedPlacement" class="mini-font">{{ selectedPlacement ? `${selectedPlacementDisplay}` : 'All' }}</span>
            </div>
            <div class="map_container__map_nav__content__placement__header__right">
              <i :class="[ isShownPlacement ? ' icon-chevronup' : 'icon-chevrondown']"></i>
            </div>
          </div>
          <div class="map_container__map_nav__content__placement__list" v-if="isShownPlacement">
            <ul id="cities" class="cities">
              <li v-for="placement in placementFilter" :key="placement.id" @click.stop="selectPlacement(placement.value, placement.label)">
                <div :class="['city', placement.value == selectedPlacement ? 'active' : '']">
                  <a class="small-font city_name">{{ placement.label }}</a>
                  <i class="adx-ic_check"></i>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="map_container__map_nav__content__coordinate">
          <div class="map_container__map_nav__content__coordinate__header" @click.stop="toggleExpand('toggleCoordinate')">
            <div class="map_container__map_nav__content__coordinate__header__left">
              <span class="mini-font strong coordinate_header">SEARCH BY COORDINATE</span>
            </div>
            <div class="map_container__map_nav__content__coordinate__header__right">
              <i :class="[ isShownCoordinate ? ' icon-chevronup' : 'icon-chevrondown']"></i>
            </div>
          </div>
          <div class="map_container__map_nav__content__mid__search_box" v-if="isShownCoordinate">
            <input 
            v-model="inputCoordinate" 
            type="text" 
            placeholder="Type Coordinate here"
            class="mini-font"
            v-on:keyup.enter="searchCoordinate">
            <i class="adx-ic_search" @click.stop="searchCoordinate"></i>
          </div>
        </div>
        
        <div class="map_container__map_nav__content__legend">
          <div class="map_container__map_nav__content__legend__header">
            <span class="mini-font strong">LEGEND</span>
          </div>
          <div class="map_container__map_nav__content__legend__list">
            <div class="list_legend">
              <span class="legend_icon"><img src="/img/icons/ic-map-gray@2x.svg" alt=""></span>
              <span class="legend_text small-font">Placement</span>
            </div>
            <div class="list_legend">
              <span class="legend_icon"><img src="/img/icons/ic-map_red@2x.svg" alt=""></span>
              <span class="legend_text small-font">Priority Placement</span>
            </div>
            <div class="list_legend">
              <div class="legend_icon street_icon"><i></i></div>
              <span class="legend_text small-font">Recommended Area</span>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="billboard">
        <div class="billboard__view-map" v-if="isShowViewMap" @click="closeMapView()">
          <div><span class="medium-font color-white"> View : {{campaignName}}</span></div>
          <div><span class="medium-font color-white">Exit Map View</span></div>
        </div>
        <div class="billboard__order">
          <div class="billboard__order__icon" @click="toggleExpand('isShownOrderSummary')">
            <img src="img/icons/adx-ic-magazine.png">
          </div>
          <div class="billboard__order__list-order" v-if="isShownOrderSummary">
            <div class="billboard__order__list-order__title">
              <span class="billboard__order__list-order__title__left">
                <i class="icon-close large-font color-grey" @click="toggleExpand('isShownOrderSummary')"/>
              </span>
              <span class="billboard__order__list-order__title__right">
                {{ listOrder.length > 1 ? listOrder.length + ' items' : listOrder.length + ' item' }}
              </span>
            </div>
            <div class="billboard__order__list-order__campaign-name">
              <div class="billboard__order__list-order__campaign-name__title">Campaign Name</div>
              <div class="billboard__order__list-order__campaign-name__input">
                <input 
                  type="text" 
                  class="billboard__order__list-order__campaign-name__input__name"
                  v-model="campaignName"
                  placeholder="Untitled Campaign"
                >
              </div>
            </div>
            <div v-if="idCampaign" class="billboard__order__list-order__view-on-map">
              <div class="left"><span class="mini-font strong">Campaign Items</span></div>
              <div class="right"><span class="mini-font color-pink strong" @click="activateMapView">View on Map</span></div>
            </div>
            <div class="billboard__order__list-order__content">
              <div 
                class="billboard__order__list-order__content__row"
                v-for="(item, index) in listOrder"
                :key="index"
              >
                <div class="billboard__order__list-order__content__row__left">
                  <div class="billboard__order__list-order__content__row__left__code">
                    Billboard, {{ item.side ? item.location.code + item.side : item.location.code }}
                  </div>
                  <div class="billboard__order__list-order__content__row__left__direction">{{ item.direction }}</div>
                </div>
                <div class="billboard__order__list-order__content__row__right" v-if="campaignOwner == user.userId">
                  <span class="delete">
                    <i class="icon-deleted" @click="removeItem(item.id)"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="billboard__order__list-order__button">
              <div class="billboard__order__list-order__button__new">
                <button class="btn-small secondary" @click="reset()">
                  Reset
                </button>
              </div>
              <div class="billboard__order__list-order__button__save">
                <button class="btn-small primary" @click="save()" :disabled="(campaignOwner != user.userId) && (campaignOwner)">
                  {{ button }}
                </button>
              </div>
              <div class="billboard__order__list-order__button__save-download">
                <button class="btn-small primary" @click="saveAndDownload()">
                  {{(campaignOwner != user.userId) && (campaignOwner) ? 'Download': 'Save & Download' }}
                </button>
              </div>
            </div>
          </div>
          <div class="billboard__order__modal" v-if="isShownModalCampaign">
            <div class="billboard__order__modal__buttons-up">
              <i 
                class="icon-close large-font color-grey" 
                @click="toggleExpand('isShownModalCampaign')"
              > </i>
            </div>
            <div class="billboard__order__modal__title">Channel Campaign</div>
            <div class="billboard__order__modal__content">
              <div class="billboard__order__modal__content__left">
                <div class="billboard__order__modal__content__left__campaign-detail">
                  <div class="billboard__order__modal__content__left__campaign-detail__title">CAMPAIGN DETAILS</div>
                  <div class="billboard__order__modal__content__left__campaign-detail__name"></div>
                  <div class="billboard__order__modal__content__left__campaign-detail__date"></div>
                </div>  
                <div class="billboard__order__modal__content__left__campaign-item"></div>  
              </div>
              <div class="billboard__order__modal__content__right"></div>
            </div>
            <div class="billboard__order__modal__buttons-down">
              <button class="btn-small secondary" @click="toggleExpand('isShownModalCampaign')">
                cancel
              </button>
              <button class="btn-small primary">
                Create Campaign
              </button>
            </div>
          </div>
        </div>
        <div class="billboard__channel">
          <div :class="[isDisable ? 'disabled': '','billboard__channel__icon']" @click="toggleExpand('isShownChannelCampaign')">
            <img src="img/icons/adx-ic-channel.png">
          </div>
          <div class="billboard__channel__list-campaign" v-if="isShownChannelCampaign">
            <div class="billboard__channel__list-campaign__title">
              <span @click="toggleExpand('isShownChannelCampaign')"><i class="icon-close"></i></span>
              <span class="strong medium-font">All Campaign</span>
            </div>
            <div class="billboard__channel__list-campaign__wrapper">
              <div class="billboard__channel__list-campaign__wrapper__content">
                <div class="section-title"><span class="micro-font">MY CAMPAIGN</span></div>
                <div class="billboard__channel__list-campaign__wrapper__content__my-campaign" v-if="myCampaign.length > 0">
                  <div 
                    class="row-content"
                    v-for="(item, index) in myCampaign"
                    :key="index"
                  >
                    <div class="row-content__left" @click="sentToListOrder(item.id)">
                      <div class="row-content__left__name">{{ item.name }}</div>
                      <div class="row-content__left__total">
                        {{ item.placement_count > 1 ? item.placement_count + ' items' : item.placement_count + ' item' }}
                      </div>
                    </div>
                    <div class="row-content__right">
                      <span class="delete">
                        <i class="icon-deleted" @click="removeCampaign(item.id)"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="subhead-mycampaign">You dont have any campaign right now</div>
                </div>
              </div>
              <div class="billboard__channel__list-campaign__wrapper__content">
                <div class="section-title"><span class="micro-font">OTHERS CAMPAIGN</span></div>
                <div class="billboard__channel__list-campaign__wrapper__content__others-campaign" v-if="othersCampaign.length > 0">
                  <div 
                    class="row-content"
                    v-for="(item, index) in othersCampaign"
                    :key="index"
                  >
                    <div class="row-content__left" @click="sentToListOrder(item.id)">
                      <div class="row-content__left__name">{{ item.name }}</div>
                      <div class="row-content__left__total">
                        {{ item.placement_count > 1 ? item.placement_count + ' items' : item.placement_count + ' item' }} 
                        - Created by  
                        {{item.user_name}}
                      </div>
                    </div>
                    <!-- <div class="row-content__right">
                      <span class="delete">
                        <i class="icon-deleted" @click="removeCampaign(item.id)"></i>
                      </span>
                    </div> -->
                  </div>
                </div>
                <div v-else>
                  <div class="subhead-otherscampaign">There is no campaign created by others</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a-modal
        v-if="isShownResetModal"
        @modal-close="toggleExpand('isShownResetModal')"
        class="reset"
        :noTitle="true"
      >
        <div slot="content">
          <div class="reset__wrapper">
            <h1 class="medium-title title">Save Campaign?</h1>
            <p class="subhead-reset">You have unsaved campaign, if you continue this proccess, you may lost your last progress, save it first?</p>
            <div class="reset__wrapper__buttons">
              <button
                type="button"
                class="btn-block secondary"
                @click.stop="resetItemOrder"
              >don't save</button>
              <button
                type="button"
                class="btn-block primary"
                @click.stop="toggleExpand('isShownResetModal')"
                @click="saveAndReset()"
                :disabled="(campaignOwner != user.userId) && (campaignOwner)"
              >Save</button>
            </div>
          </div>
        </div>
      </a-modal>
  </div>
</template>

<script>
import Input from '@/components/Form/Input';
import Badge from '@/components/Badge';
import LoadingPrimary from '@/components/Loading/Primary'
import { globalMixins } from "@/lib/mixins/globalMixins"
import { mapGetters } from "vuex"
import { gmapApi } from 'vue2-google-maps'
import InfowWindow from '@/views/BillboardMap/infoWindow'

import { viewPrice } from '@/lib/config'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { restEdge } from "@/api/edgeUrls";
import {
  AInput,
  AModal
} from "ui-kit-v1";

import FileSaver from "file-saver";

export default {
  name: 'adx-billboard-map',
  components: {
    'adx-loading': LoadingPrimary,
    'info-window': InfowWindow,
    'a-input': AInput,
    'adx-badge': Badge,
    'adx-input': Input,
    "a-modal": AModal
  },
  mixins: [globalMixins],
  created() {
    this.loadType()
    this.loadCity()
    this.loadCode()
    this.loadStreets()
    this.loadBillboard()
    this.loadAllCampaign()
  },
  data() {
    return {
      listCampaign: [],
      myCampaign: [],
      othersCampaign: [],
      markerList: [],
      idList: [],
      campaignName: 'Untitled Campaign',
      listOrder: [],
      toggleSide: true,
      toggleButton: false,
      maxPrice: '0',
      minPrice: '0',
      isShowPrice: false,
      showErrorMsg: false,
      verifiedIcon:
       { scaledSize: {width: 50, height: 50},
        url :  '/img/icons/marker/verify-multiple-icon@2x.png'
      },
      opacity: 1,
      listStreet: [],
      listCity: [],
      filteredCity: [],
      allListCity: [],
      center: { lat: -6.208049, lng: 106.844379 }, // jakarta as a default center view
      zoom: 7,
      polyLineOpts: {
        strokeColor: '#2106f9'
      },
      streetCoordinates: [],
      selectedCity: null,
      selectedCityDisplay: "",
      selectedPlacement: '',
      selectedPlacementDisplay: "All",
      infoWindowPosition: null,
      infoWindowOptions: {
        content: ''
      },
      infoWindowOpen: false,
      currentWindow: null,
      loadDataStreet: true,
      loadDataCity: true,
      loadingMap: true,
      loadDataBillboard: true,
      listBillboard: [],
      filteredBillboard: [],
      markers: [],
      // current marker index
      currentMidx: null,
      infoWindowBillboard: {
        content: '',
      },
      infoWindowBillboardOpen: false,
      infoWindowBillboardPosition: null,
      listType: [],
      listCheckedType: [],
      timeout: null,
      requesting: false,
      billboardAsCenter: false,
      inputSearch: "",
      searchCity: "",
      listCode: [],
      filteredCode: [],
      selectedCode: "",
      isShownPlacement: false,
      isShownCoordinate: false,
      toggleCoordinate: false,
      inputCoordinate: '',
      position: null,
      placements: null,
      isShownType: false,
      placementFilter: [
        {
          'id' : 0,
          'value' : '',
          'label' : 'All'
        },
        {
          'id' : 1,
          'value' : 'true',
          'label' : 'Priority Placement'
        },
        {
          'id' : 2,
          'value' : 'false',
          'label' : 'Non-priority Placement'
        }
      ],
      pov: null,
      showMiniMap: false,
      panorama: null,
      mapObject: null,
      view : viewPrice,
      isShownOrderSummary: false,
      isShowViewMap: false,
      isShownModalCampaign: false,
      isShownChannelCampaign: false,
      isShownResetModal: false,
      idCampaign: null,
      button: 'Save',
      campaignPlacement: [],
      isSaved: true,
      isDisable: false,
      campaignOwner: null,
    }
  },
  watch: {
    loadDataBillboard: function(newValue, oldValue) {
      if (!newValue) {
        this.setCenter()
      }
    },
    loadDataStreet: function(newValue, oldValue) {
      if (!newValue) {
        this.setCenter()
      }
    }
  },
  methods: {
    async saveAndReset() {
      await this.save();
      
      this.isSaved && this.resetItemOrder();
    },
    updateListOrder(item) {
      this.listOrder = this.listOrder.filter(currentItem => currentItem.id !== item.id);
    },
    resetItemOrder() {
      this.idCampaign = null;
      this.campaignOwner = null;
      this.campaignName = '';
      this.isShownResetModal = false;
      this.listOrder = [];
      this.button = 'Save';
      this.isSaved = true;
    },
    async sentToListOrder(id) {
      this.isShownChannelCampaign = false
      this.isShownOrderSummary = true
      const { data, status } = await api.get(restEdge.billboardCampaignDetail(id), {
        needToken: true, 
        useRestEdge: true 
      });

      if (!this.isSaved) {
        this.isShownResetModal = true;
        return;
      }

      if (status == 200) {
        this.idCampaign = data.id;
        this.campaignOwner = data.owner
        this.listOrder = data.placements.map(placement => {
          let item = new Object();
          item.id = placement.id;
          item.location = new Object();
          item.location.code = placement.location.code;
          item.location.city = new Object();
          item.location.city.id = placement.location.city.id;
          item.location.city.name = placement.location.city.name;
          item.direction = placement.direction;
          item.side = placement.side;

          return item;
        });
        this.campaignName = data.name;
        this.button = 'Update';
      } else {
        this.showNotificationAlert("Error", `Failed with status code ${status}.`, "danger");
      }
    },
    async loadAllCampaign() {
      // get all campaigns from calling api.
      
      const params = { owner: this.user.userId };
      const { data, status } = await api.get(restEdge.billboardCampaign, {
        params: params,
        needToken: true,
        useRestEdge: true
      });

      if (status == 200) {
        this.listCampaign = data;
        let idMyCampaign = []
        let idOthersCampaign = []
        this.myCampaign = []
        this.othersCampaign = []
        
        this.listCampaign.map(el =>{
          if (el.owner == this.user.userId){
            if(!idMyCampaign.includes(el.id)) {
              this.myCampaign.push(el)
              idMyCampaign.push(el.id)
              }
          }else{
            if(!idOthersCampaign.includes(el.id)){
              this.othersCampaign.push(el)
              idOthersCampaign.push(el.id)
            }
          }
        })
      } else {
        this.showNotificationAlert("Error", `Failed with status code ${status}.`, "danger");
      }
    },
    async removeCampaign(id) {
      const response = await api.destroy(restEdge.deleteBillboardCampaign(id), {
        needToken: true,
        useRestEdge: true
      });

      if (response.status == 200) {
        this.showNotificationAlert("Success", "Campaign has been deleted.", "success");
        this.loadAllCampaign();
      } else {
        this.showNotificationAlert("Danger", `Failed with status code ${response.status}`, "danger");
      }
    },
    findIndex(listx, idx) {
      for (var i = 0; i < listx.length; i++) {
        let listPlacement = listx[i].record.placement;
        for (var j = 0; j < listPlacement.length; j++) {
          if (listPlacement[j].id == idx) {
            return i;
          }
        }
      }
    },
    openInfoWindow(id) {
      let indeks = this.findIndex(this.markerList, id);
      this.toggleInfoWindowMarker(this.markerList[indeks], this.idList[indeks]);      
    },
    async save() {
      let status_code = 200
      let placements = this.listOrder.map(item => item.id);
      let body = {
        name: this.campaignName,
        owner: this.user.userId || null,
      };

      if (!placements.length) {
        this.showNotificationAlert("Danger", `Campaign can not be empty.`, "danger");
        return;
      }

      if (this.idCampaign) {
        body = { 
          ...body, 
          "id": this.idCampaign,
          placement_ids: placements
        };
        const { data, status } = await api.patch(restEdge.updateBillboardCampaign(this.idCampaign), body, {
          needToken: true,
          useRestEdge: true
        });

        if (status == 200) {
          this.showNotificationAlert("Success", "Awesome! Campaign has been updated.", "success");
          this.loadAllCampaign();
          this.isSaved = true;
        } else {
          status_code = status
          this.showNotificationAlert("Danger", `Failed with status code ${status}`, "danger");
        }
      } else {
        body = {
          ...body,
          placements: placements
        };
        const { data, status } = await api.post(restEdge.createBillboardCampaign, body, {
          needToken: true,
          useRestEdge: true
        });

        if (status == 200) {
          this.showNotificationAlert("Success", "Awesome! Campaign has been created.", "success");
          this.loadAllCampaign();
          this.button = 'Update';
          this.idCampaign = data.id;
          this.isSaved = true;
        } else {
          status_code = status
          this.showNotificationAlert("Danger", `Failed with status code ${status}`, "danger");
        }
      }


      return status_code
    },
    async downloadBillboard() {
      const { data, status } = await api.get(restEdge.downloadBillboard(this.idCampaign), { 
        needToken: true,
        useRestEdge: true,
        responseType: "blob"
      });

      if (status !== 200) {
        this.showNotificationAlert("Error", `Download failed with status code ${status}.`, "danger");
      } else if (status == 200){
        let fileName = `billboard-campaign.zip`;
        await FileSaver.saveAs(data, fileName);
      }
    },
    async saveAndDownload() {
      if (this.campaignOwner == this.user.userId){
        let status = await this.save()
        if (status == 200) {
        await this.downloadBillboard() 
        }
      }else{
        await this.downloadBillboard() 
      }
    },
    updateItems(item) {
      if (!this.listOrder.some(currentItem => currentItem.id === item.id)) {
        this.listOrder.push(item);
        this.isSaved = false;
      }
    },
    removeItem(id) {
      this.listOrder = this.listOrder.filter(item => item.id !== id);
      let indeks = this.findIndex(this.markerList, id);
      this.markerList.filter(item => item !== this.markerList[indeks]);
      this.isSaved = false;
    },
    searchCoordinate() {
      if (this.inputCoordinate === "") {
        this.showNotificationAlert("Error", "Input coordinate must not be empty.", "danger");
      } else {
        let crd = this.inputCoordinate.split(',');
  
        if (crd.length < 2) {
          this.showNotificationAlert("Error", "Invalid input coordinate.", "danger");
        } else {
          let parseLat = Number.parseFloat(crd[0]);
          let parseLng = Number.parseFloat(crd[1]);
          this.position = { lat: parseLat, lng: parseLng };
          this.changeCenterAndZoom(this.position);
          this.inputCoordinate = '';
        }
      }
    },
    windowClicked() {
      if (this.infoWindowBillboardOpen) {
        this.closeWindowBillboard()
      }
    },
    updateData(){
      this.infoWindowBillboard.content = this.renderInfoWindowMarker()
    },
    checkCode(selectedCode){
      let lastChar = selectedCode.slice(-1)
      let bbCode = null
      if(/^[a-zA-Z]+$/.test(lastChar)){
        bbCode = selectedCode.slice(0,-1)
      }else{
        bbCode = selectedCode
      }
      return bbCode
    },
    filterBillboard() {
      let results = []
      if (this.isShowViewMap){
        results = this.listBillboard.filter( el =>{
          if(this.campaignPlacement.includes(el.code)){
            return true
          }
        })
      } else {
        results = this.listBillboard
      }
      let code = null
      code = this.checkCode(this.selectedCode)

      if(code) {
        results = results.filter(billboard => {
          return billboard.code.toLowerCase() == code.toLowerCase()
        })
      }

      if (this.selectedPlacement) {
        
        results = results.filter(billboard => {
          //checking is placement billboard isrecommendation or not
          let isRecommendation = []
          let reco = 0
          let not_reco = 0
          billboard.placement.map(el =>{
            this.isRecommendation(el.top_recommendation) ? reco += 1 : not_reco += 1
          })
          let halfRecommendation = false
          let recommendation = false
          let notRecommendation =  false

          if ((not_reco > 0) && (reco > 0)){
            halfRecommendation = true
          }else if((reco > 0) && (not_reco == 0)){
            recommendation = true
          }else if((reco == 0) && (not_reco > 0)){
            notRecommendation =  true
          }

          if(this.selectedPlacement == 'true'){
            if (halfRecommendation || recommendation ){
              return true
            } 
          }else if(this.selectedPlacement == 'false'){
            if (halfRecommendation || notRecommendation){
              return true
            }
          }         
        })
      }
      
      //checking billboard media type
      if (this.listCheckedType.length > 0) {
        results = results.filter(billboard => {
          return this.listCheckedType.includes(billboard.media_type)
        })
      }
      
      //filter price
      if(this.maxPrice && this.minPrice){
        if(this.convertToInt(this.maxPrice) > 0){
        results = results.filter(billboard => {
          let inRange = 0
          billboard.placement.map(el =>{
              if(this.isInPriceRange(el.price_per_m2)){
                inRange += 1
              }
          })

          if (inRange > 0){
            return true
          }
          })
        }
      }

      this.filteredBillboard = results
      this.mappingBillboardMarker()
    },
    showMap() {
      this.loadingMap = false
    },
    loadStreets() {
      // get all streets based on selected city
      (async () => {
        this.loadDataStreet = true
        this.listStreet = []
        let params = { 
          city: this.selectedCity || undefined
        };
        const { data, status } = await api.get(restEdge.listStreet, { 
          params: params,
          needToken: true,
          useRestEdge: true 
        });

        if (status == 200) {
          if (data.length > 0) {
            this.listStreet = data
          }
          this.loadDataStreet = false
        } else {
          console.log(`Failed to fetch data. ${status}`)
        }
      })();
    },
    loadCity() {
      // get all city from data api.
      (async () => {
        this.loadDataCity = true
        const params = {};
        const { data, status } = await api.get(restEdge.listCity, { 
          params: params,
          needToken: true,
          useRestEdge: true 
        });

        if (status == 200) {
          this.allListCity = data
          this.listCity = this.allListCity
          this.loadDataCity = false
        }
      })();
    },
    loadBillboard() {
      (async () => {
        this.loadDataBillboard = true
        this.listBillboard = []
        let params = { 
          city: this.selectedCity || undefined
        };
        const { data, status } = await api.get(restEdge.listBillboard, { 
          params: params,
          needToken: true,
          useRestEdge: true  
        });

        if (status == 200) {
          this.listBillboard = data
          this.filterBillboard()
          this.loadDataBillboard = false
        }
      })();
    },
    loadType() {
      (async() => {
        const params = {};
        const { data, status } = await api.get(restEdge.listBillboardType, { 
          params: params,
          needToken: true,
          useRestEdge: true 
        });

        if (status == 200) {
          this.listType = data;
          this.listType.forEach(record => {
            this.listCheckedType.push(record.name)
          })
        }
      })();
    },
    loadCode() {
      (async ()=> {
        const params = {};
        const { data, status } = await api.get(restEdge.listBillboardCode, { 
          params: params,
          needToken: true,
          useRestEdge: true
        })

        if (status == 200) {
          this.listCode = data;
        }
      })();
    },
    mappingBillboardMarker() {
      this.markers = []
      this.filteredBillboard.forEach(record => {
        let coordinate = this.transformCoordinate(
          {latitude: record.latitude, longitude: record.longitude}
        )
        this.markers.push({ 
          id: record.id,
          position: coordinate, 
          record: record
        })
      })
    },
    setBillboardCenter() {
      let record = this.filteredBillboard[0]
      let coordinate = this.transformCoordinate({
        latitude: record.latitude,
        longitude: record.longitude
      })
      this.changeCenterAndZoom(coordinate)
    },
    setStreetCenter() {
      // take the first data coordinate and make it as a center view.
      let coordinate = this.listStreet[0].coordinates[0]
      if (coordinate.latitude && coordinate.longitude) {
        coordinate = this.transformCoordinate(coordinate)
        this.changeCenterAndZoom(coordinate)
      } 
    },
    setCenter() {
      // use billboard as center
      if (!this.loadDataStreet && !this.loadDataBillboard) {
        if (this.billboardAsCenter && this.filteredBillboard.length > 0) {
          this.setBillboardCenter()
        } else {
          // use street as center
          if (this.listStreet.length > 0) {
            this.setStreetCenter()
          } else {

            //if no street but bb exist
            if (this.filteredBillboard.length > 0) {
              this.setBillboardCenter()
            } else {
               this.loadingMap = false
            }
          }
        }
      }
    },
    changeCity(id, name) {
      // select the city, and load the streets
      this.loadingMap = true
      this.selectedCity = id
      this.selectedCityDisplay = name
      this.closeWindowBillboard()
      this.loadStreets()
      this.loadBillboard()
    },
    selectCity(id, name) {
      if (this.selectedCity == id) return
      this.selectedCode = ""
      this.inputSearch = ""
      this.resetCenter()
      this.changeCity(id, name)
    },
    selectPlacement(value, name) {
      this.selectedPlacement = value
      this.selectedPlacementDisplay = name
      this.resetCenter()
      this.filterBillboard()
      this.isShownPlacement = true
    },
    selectType(type) {
      if (this.listCheckedType.includes(type)) {
        let index = this.listCheckedType.indexOf(type)
        if (index > -1) {
          this.listCheckedType.splice(index, 1)
        }
      } else {
        this.listCheckedType.push(type)
      }
    },
    changeCenterAndZoom(coordinate) {
      this.center = coordinate
      this.zoom = 13
    },
    transformAllCoordinate(coordinates) {
      let newData = []
      coordinates.forEach(coordinate => {
        newData.push(this.transformCoordinate(coordinate))
      })
      
      return newData
    },
    transformCoordinate(coordinate) {
      return {
        lat: parseFloat(coordinate.latitude),
        lng: parseFloat(coordinate.longitude)
      }
    },
    showWindow(coordinate, reason, name, id) {
      if (this.currentWindow == id) {
        return
      }
      this.currentWindow = id
      this.infoWindowOpen = true
      this.infoWindowPosition = this.transformCoordinate(coordinate)
      this.infoWindowOptions.content = this.renderInfoWindow(name, reason)
    },
    closeWindow() {
      this.infoWindowOpen = false
      this.currentWindow = null
      this.placements = null
    },
    renderInfoWindow(name, reason) {
      return `<div class="info_window">
        <div class="info_window_wrapper">
          <div class="info_section">
            <div class="row_data">
              <span class="left top">Street Name</span>
            </div>
            <div class="row_data">
              <span class="bottom">${name}</span>
            </div>
            <div class="separator"></div>
            <div class="row_data">
              <span class="left">Reason</span>
            </div>
            <div class="row_data">
              <span class="bottom">${reason}</span>
            </div>
            </div>
          </div>
        </div>
      </div>`
    },
    toggleInfoWindowMarker(marker, idx) {
      !this.markerList.includes(marker) && this.markerList.push(marker);
      !this.idList.includes(idx) && this.idList.push(idx);
      
      this.placements = marker.record
      this.infoWindowBillboardPosition = marker.position

      if (this.currentMidx == idx) {
        this.infoWindowBillboardOpen = !this.infoWindowBillboardOpen
      } else {
        this.infoWindowBillboardOpen = true
        this.currentMidx = idx
      }
    },
    closeWindowBillboard() {
      this.infoWindowBillboardOpen = false
      this.currentMidx = null
    },
    renderInfoWindowMarker() {
      return `${this.$refs['window'].$el.outerHTML}` 
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    applyFilter() {
      if (this.requesting) return
      let _this = this
      this.timeout = setTimeout(() => {
        _this.requestFinish()
      }, 3000)
      this.requesting = true
      this.resetCenter()
      this.filterBillboard()
    },
    requestFinish() {
      this.requesting = false
    },
    applyFilterPrice(){
      if(this.maxPrice && this.minPrice){
        if (this.convertToInt(this.maxPrice) < this.convertToInt(this.minPrice)){
          this.showErrorMsg = true
          return 
        }
      }
      this.showErrorMsg =false
      this.filterBillboard()
    },
    convertToInt(value){
      return parseInt(value.replace(/\./g, ''))
    }, 
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    clearFilter(filterType) {
      filterType == 'type' ? this.listCheckedType = [] : 
      this.maxPrice = '0' 
      this.minPrice = '0'
      this.showErrorMsg =false
      this.filterBillboard()
    },
    clearFilter(filterType) {
      filterType == 'type' ? this.listCheckedType = [] : 
      this.maxPrice = '0' 
      this.minPrice = '0'
      this.showErrorMsg =false
      this.filterBillboard()
    },

    getIcon(data) {
      let icon = { scaledSize: {width: 50, height: 50} }
      if(data.placement.length > 1){
        icon.url = this.getIconMultipleMarker(data.media_type, data.placement)
      }else{
        if (this.isRecommendation(data.placement[0].top_recommendation)) {
          icon.url = this.getIconMarker(data.media_type, true)
        } else {
          icon.url = this.getIconMarker(data.media_type, false)
        }
      }
      return icon
    },
    getIconMediaType(mediaType) {
      let iconUrl = '/img/icons'
      switch(mediaType.toLowerCase()) {
        case 'billboard':
          iconUrl = `${iconUrl}/ic-billboard.svg`
          break
        case 'baliho':
          iconUrl = `${iconUrl}/ic-baliho.svg`
          break
        case 'bando':
          iconUrl = `${iconUrl}/ic-bando.svg`
          break
        case 'jpo':
          iconUrl = `${iconUrl}/ic-jpo.svg`
          break
        case 'videotron':
          iconUrl = `${iconUrl}/ic-videotron.svg`
          break
        default:
          iconUrl = `${iconUrl}/ic-billboard.svg`
      }

      return iconUrl
    },
    getIconMultipleMarker(mediaType, placement){
      let iconUrl = '/img/icons/marker'
      let verified = []
      let recommendation = []
      let folder = null
      let type = null

      placement.map(el =>{
        recommendation.push(
          this.isRecommendation(el.top_recommendation)
        )
      })

      //check verified for multiple placement
      if (recommendation.includes(true) && recommendation.includes(false)){
        folder = 'multipleside/halfrecommendation'
        type = '1'
      }else if(recommendation.every(Boolean) == false){
        folder = 'multipleside/notrecommendation'
        type = '3'
      }else if(recommendation.every(Boolean) == true){
        folder= 'multipleside/fullrecommendation'
        type = '2'
      }

      switch(mediaType.toLowerCase()) {
        case 'billboard':
          iconUrl = `${iconUrl}/${folder}/ic-map-double-side-${type}-billboard.png`
          break
        case 'baliho':
          iconUrl = `${iconUrl}/${folder}/ic-map-double-side-${type}-baliho.png`
          break
        case 'bando':
          iconUrl = `${iconUrl}/${folder}/ic-map-double-side-${type}-bando.png`
          break
        case 'jpo':
          iconUrl = `${iconUrl}/${folder}/ic-map-double-side-${type}-jpo.png`
          break
        case 'videotron':
          iconUrl = `${iconUrl}/${folder}/ic-map-double-side-${type}-videotron.png`
          break
        default:
          iconUrl = `${iconUrl}/${folder}/ic-map-double-side-${type}-billboard.png`
      }
      return iconUrl
    },
    getIconMarker(mediaType, recommendation, isVerified) {
      let iconUrl = null
      let iconFolder = null
      let color = null

      if (recommendation) {
        iconFolder =  '/img/icons/marker/recommendation'
        color = 'red'
      } else {
        iconFolder = '/img/icons/marker'
        color = 'gray'
      }

      switch(mediaType.toLowerCase()) {
        case 'billboard':
          iconUrl = `${iconFolder}/ic-map-${color}-billboard@2x.png`
          break
        case 'baliho':
          iconUrl = `${iconFolder}/ic-map-${color}-baliho@2x.png`
          break
        case 'bando':
          iconUrl = `${iconFolder}/ic-map-${color}-bando@2x.png`
          break
        case 'jpo':
          iconUrl = `${iconFolder}/ic-map-${color}-jpo@2x.png`
          break
        case 'videotron':
          iconUrl = `${iconFolder}/ic-map-${color}-videotron@2x.png`
          break
        default:
          iconUrl = `${iconFolder}/ic-map-${color}-billboard@2x.png`
      }
      return iconUrl
    },
    getVerifiedIcon(data){
      let opacity = 1
      let is_verified = true
      let isStaff = this.user.isStaff
      let isSuperuser = this.user.isSuperuser

      if (data.placement.length > 1) {
        data.placement.forEach(el => {
          // if one of these placements not verified
          // then verified status will be false
          if (!el.is_verified) {
            is_verified = false
          }
        })
      } else {
        is_verified = data.placement[0].is_verified
      }
      
      // check if user not staff and not superuser
      if (!isStaff && !isSuperuser) {
        opacity = 0
      } else {
        // if staff or superuser
        // and not verified
        if (!is_verified) {
          opacity = 0
        }
      }
      
      return opacity
    },
    isRecommendation(recommendation) {
      if (recommendation) {
        if (recommendation.toLowerCase() == 'ok') {
          return true
        }
      }

      return false
    },
    isInPriceRange(price){
      if(price){
        if (price >= this.convertToInt(this.minPrice) && price <= this.convertToInt(this.maxPrice)){
          return true
        }
      }

      return false
    },
    isVideotron(type) {
      if (type) {
        if (type.toLowerCase() == 'videotron') {
          return true
        }
      }

      return false
    },
    loadBillboardImg(photo) {
      if (photo) {
        if (photo.thumbnail_320) {
          return photo.thumbnail_320
        }
      }

      return '/img/notfound/img-placeholder-landscape@2x.png'
    },
    resetCenter() {
      this.billboardAsCenter = false
    },
    toggleSearchBox() {
      let className = 'show'
      let search = this.$refs['searchBox']
      if (search.classList.contains(className)) {
        search.classList.remove(className)
      } else {
        search.classList.add(className)
        this.$refs['inputSearch'].focus()
      }
    },
    toggleSideMenu(){
      this.toggleSide = !this.toggleSide;
      this.toggleButton = !this.toggleButton;
    },
    goToHome() {
      this.$router.push({ name: 'home' })
    },
    searchCode() {
      this.closeWindowBillboard()
      if (!this.inputSearch) {
        this.selectedCode = ""
        this.filterBillboard()
        return
      }

      this.selectedCode = this.inputSearch
      let code = null
      code = this.checkCode(this.selectedCode)
      let selectedData = this.listCode.filter(record => {
        return record.code.toLowerCase() == code.toLowerCase()
      })
      if (selectedData.length > 0) {
        let data = selectedData[0]
        if (data.city == this.selectedCity) {
          this.billboardAsCenter = true
          this.filterBillboard()
          this.setBillboardCenter()
        } else {
          this.billboardAsCenter = true
          this.changeCity(data.city, data.city_name)
        }
      } else {
        this.showNotificationAlert("Error", "Data no found.", "danger")
      }
    },
    clearSearch() {
      this.inputSearch = ""
      this.selectedCode = ""
      this.resetCenter()
      this.filterBillboard()
    },
    toggleExpand(value){
      if (value == "placement"){
        this.isShownPlacement = !this.isShownPlacement
        this.isShowPrice = false
        this.isShownType = false
        this.isShownCoordinate = false
      } else if (value == "toggleCoordinate") {
        this.isShownCoordinate = !this.isShownCoordinate;
        this.isShownType = false
        this.isShownPlacement = false
        this.isShowPrice =  false
      } else if(value == "price"){
        this.isShowPrice =  !this.isShowPrice
        this.isShownType =false
        this.isShownPlacement = false
        this.isShownCoordinate = false
      } else if (value === "isShownOrderSummary") {
        this.isShownOrderSummary = !this.isShownOrderSummary;
        this.isShownChannelCampaign = false;
      } else if (value === "isShownModalCampaign") {
        this.isShownModalCampaign = !this.isShownModalCampaign;
      } else if (value === "isShownChannelCampaign") {
        this.isDisable ? '' : this.isShownChannelCampaign = !this.isShownChannelCampaign;
        this.isShownOrderSummary = false;
      } else if (value === "isShownResetModal") {
        this.isShownResetModal = !this.isShownResetModal;
      } else {
        this.isShownType = !this.isShownType
        this.isShownPlacement = false
        this.isShowPrice =  false
        this.isShownCoordinate = false
      }
    },
    reset() {
      if (this.isSaved) { 
        if (this.idCampaign) {
          this.resetItemOrder();
        }
      } else {
        this.toggleExpand('isShownResetModal')
      }
    },
    async activateMapView(){
      this.isDisable = true
      this.isShowViewMap = true
      this.isShownOrderSummary = false
      this.filterCity()  
      this.filterplacementCampaign()   
      this.listCity = this.filteredCity
      if(this.selectedCity == this.filteredCity[0].id){
        this.closeWindowBillboard()
        this.loadStreets()
        this.loadBillboard()
      }else{
        this.selectCity(this.filteredCity[0].id, this.filteredCity[0].name )
      }
    }, 
    filterplacementCampaign(){
      this.campaignPlacement = []
      this.listOrder.map( el =>{
        this.campaignPlacement.push(el.location.code)
      })
    },
    filterCity(){
      this.filteredCity = []
      let tempCity = []
      let results = []
      this.listOrder.map( el =>{
        if(!tempCity.includes(el.location.city.id)){
          tempCity.push(el.location.city.id)
          results.push(el.location.city)
        }
      })
      this.filteredCity = results.sort((a, b) => a.name.localeCompare(b.name));
    },
    closeMapView(){
      this.isDisable = false
      this.isShowViewMap = false
      this.listCity = this.allListCity
      this.filterBillboard()
    },
    changeView() {
      if (this.panorama.getVisible()) {
        this.mapObject.setOptions({ disableDefaultUI: true })
        this.mapObject.setZoom(17)
        this.showMiniMap = true
      } else {
        this.mapObject.setOptions({ disableDefaultUI: false })
        this.mapObject.setZoom(15)
        this.showMiniMap = false
      }
    },
    changePosition() {
      this.mapObject.setCenter(this.panorama.getPosition())
    },
    async setMapAndPanorama() {
      this.mapObject = await this.$refs.map.$mapPromise
      let panoOptions = { 
        visible: false,
        zoom: 1,
        addressControl: true,
        enableCloseButton: true
      }
      let myMap = this.$refs['panoContainer']
      this.panorama = new google.maps.StreetViewPanorama(myMap, panoOptions)
      this.panorama.addListener('visible_changed', this.changeView)
      this.panorama.addListener('position_changed', this.changePosition)

      this.mapObject.setOptions({ mapTypeControl: false, fullscreenControl: false })
      this.mapObject.setStreetView(this.panorama)
      this.mapObject.addListener('tilesloaded', this.showMap)
    },
    initialSlide(div, style){
      var slides = document.getElementsByClassName(div);
      for (var i = 0; i < slides.length; i++){
        slides[i].style.display = "none"
      }

      if(slides.length && slides.length%2 == 0){
        slides[slides.length/2 - 1].style.display = style
      }
    }
  },
  computed: {
    filteredList() {
      return this.listCity.filter((city) => {
        return city.name.toLowerCase().includes(this.searchCity.toLowerCase())
      })
    },
    google: gmapApi,
    ...mapGetters({
      user: "account"
    })
  },
  updated: function () {
    this.$nextTick(function () {
      if(this.placements){
        this.initialSlide("directions", "block")
        this.initialSlide("photo", "flex")
        this.initialSlide("recommendations", "block")
        if(this.placements.placement.length > 1){
          this.initialSlide("numberText", "block")
        }
        this.initialSlide("side", "flex")
        if(this.view == 'true'){
          this.initialSlide("price", "block")
        }
        this.initialSlide("code", "flex")
        this.initialSlide("button-section", "flex")
      }
    })
  },
  mounted: function() {
    this.setMapAndPanorama()
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>

<style lang="scss">
@import '~@/styles/variables';

.info_content {
  display: flex;
  flex-direction: column;
}

.info_window {
  display: flex;
  flex-direction: column;
  width: 257px;
  height: 480px;

  .info_window_wrapper {
    height: 100%;
    width: 100%;

    .thumbnail_section {
      position: relative;
      height: 175px;
      margin-bottom: 16px;
      
      a{
        cursor: default;
      }

      .bg_img {
        margin-top: -4px;
        width: 257px;
        height: 175px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        object-fit: cover;
        cursor: pointer;
        animation: fadein 2s;
        -moz-animation: fadein 2s; /* Firefox */
        -webkit-animation: fadein 2s; /* Safari and Chrome */
        -o-animation: fadein 2s; /* Opera */
      }
      @keyframes fadein {
          from {
              opacity:0;
          }
          to {
              opacity:1;
          }
      }
      @-moz-keyframes fadein { /* Firefox */
          from {
              opacity:0;
          }
          to {
              opacity:1;
          }
      }
      @-webkit-keyframes fadein { /* Safari and Chrome */
          from {
              opacity:0;
          }
          to {
              opacity:1;
          }
      }
      @-o-keyframes fadein { /* Opera */
          from {
              opacity:0;
          }
          to {
              opacity: 1;
          }
      }
      .prev, .next {
        cursor: pointer;
        position: absolute;
        top: 55%;
        width: auto;
        padding: 5px;
        margin-top: -22px;
        margin-left: 8px;
        color: black;
        font-weight: bold;
        font-size: 18px;
        transition: 0.6s ease;
        user-select: none;
        border-radius: 25px;
        background-color: #fff;
      }
      .next {
        left: 210px;
      }
      // .prev:hover, .next:hover {
      //   //background-color: #fff;
      // }
      .numberText{
        position: absolute;
        // top: 33%;
        left: 215px;
        height: 24px;
        width: 35px;
        padding: 5px;
        font-family: CoreSansC-65;
        font-size: 11px;
        font-weight: bold;
        color: white;
        background-color: rgba(38, 38, 38, 0.8);
        border-radius: 12px;
        text-align: center;
      }
    }

    .info_section {
      padding: 0 16px 16px 16px;
      max-height: 230px;
      overflow-y: auto;

      .row_data {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;

        &:last-of-type {
          margin-bottom: 0;
        }

        span {
          display: block;
          width: 50%;
          font-size: 13px;

          &.left {
            color: #999999;
          }

          &.top{
            margin-top: 24px;
          }

          &.right {
            text-align: right;
          }

          &.bottom{
            width: 100%;
          }
        }
    }

    .price_note {
      margin-bottom: 10%;
      span {
        font-style: italic;
        font-size: 13px;
      }
    }

      .separator {
        border-bottom: 1px solid #e5e5ea;
        margin-top: 16px;
        margin-bottom: 16px;
      }
    }

    .hide {
      display: none;
    }
  }
}

.gm-style {
  .gm-style-iw-c {
    padding: 0;
  }

  .gm-style-iw-d {
    overflow: hidden !important;
  }
}

.gm-ui-hover-effect {
  opacity: .6;
  background: #fff !important;
  margin: 12px !important;
  border-radius: 18px;
  width: 27px !important;
  height: 27px !important;
  top: 0px !important;
  right: -1px !important;

  img{
    margin: 5.5px !important;
  }
}

.map_container__map_nav__content__price__input__wrapper{
  .min-price{
    input{
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      border-right: unset;
      font-size: 13px;
    }

    label{
      font-size: 12px;
    }
  }

  .max-price{
    input{
      font-size: 13px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    label{
      font-size: 12px;
    }
  }
}

  .billboard {
    position: fixed;
    width: 100%;
    max-width: 500px;
    height: 5%;
    top: 16px;
    right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &__view-map{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 361px;
      height: 40px;
      border-radius: 20px;
      padding: 0 16px;
      background: #ff2d55;
      box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.16);
      margin-right: 8px;
      cursor: pointer;
    }

    &__order {
      display: flex;
      align-items: center;
      margin-right: 8px ;

      &__icon{
        z-index: 4;
        width: 35px;
        height: 35px;
        border-radius: 20px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px var(--pale-grey);
        background-color: #ffffff;
        cursor: pointer;

        .badge {
          top: -4px;
          position: absolute;
          min-width: 18px;
          height: 18px;
          right: 40px;
          top: -8px;
          
          &.small {
            line-height: 0.9;
            padding-left: 5px;
          }
          
          &.big {
            line-height: 1;
            font-size: 10px;
          }
        }
      }

      &__list-order {
        position: fixed;
        top: 58px;
        right: 65px;
        width: 320px;
        height: 420px;
        border-radius: 8px;
        box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px var(--pale-grey);
        background-color: #ffffff;

        &__title{
          display: flex;
          justify-content: flex-start;

          &__left {
            width: 109px;
            height: 13px;
            font-family: CoreSansC-65;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.2px;
            color: var(--black);
            flex-grow: 5;
            padding: 15px 0 0 15px;
            cursor: pointer;
            
            .icon-close {
              margin-left: -5px;
              padding-left: 0px;
            }
          }

          &__right {
            width: 85px;
            height: 12px;
            font-family: CoreSansC-45;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.1px;
            text-align: right;
            color: var(--black);
            flex-grow: 5;
            padding: 15px 15px 0 0;
          }
        }

        &__campaign-name {
          padding: 26px 14px 0px 14px;
          display: flex;
          flex-direction: column;
          height: 90px;
          margin-bottom: 20px;

          &__title {
            margin-bottom: 8px;
            font-size: 13px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;

            &__left {
              font-size: 13px;
              font-weight: bold;
            }
            
            &__right {
              font-size: 13px;
            }
          }

          &__input {
            &__name {
              width: 292px;
              height: 48px;
              border-radius: 4px;
              border: solid 1px #d5d5da;
              font-size: 14px;
              padding-left: 14px;
            }
          }
        }

        &__view-on-map{
          display: flex;
          justify-content: space-between;
          padding: 0 16px;

          .right{
            cursor:pointer;
          }
        }

        &__content {
          height: 220px;
          overflow-x: hidden;
          // margin-top: 30px;

          &__row {
            display: flex;
            justify-content: flex-start;
            border-bottom: 1px solid $pale-grey;
            width: 290px;
            margin: 0px 15px 0px 15px;
            padding: 10px 10px 10px 0px;

            &__left {
              flex-grow: 5;
              width: 70%;
              cursor: pointer;

              &__code {
                font-size: 13px;
                color: $black;
              }

              &__direction {
                font-size: 13px;
                color: #878787;
              }
            }

            &__right {
              flex-grow: 5;
              padding: 20px 0px 0 63px;
              width: 0%;

              .delete:hover {
                cursor: pointer;
              }
            }
          }

          &__row:hover {
            background-color: #f5f5fa;
          }
        }

        &__button {
          display: flex;
          justify-content: space-evenly;
          padding-top: 10px;

          &__new {
            .btn-small {
              width: 60px;
              font-size: 13px;
              font-weight: bold;
              letter-spacing: -0.1px;
              border: solid 1px #878787;
            }
          }
          
          &__save {
            .btn-small {
              width: 63px;
              font-size: 13px;
              font-weight: bold;
              letter-spacing: -0.1px;
            }
          }

          &__save-download {
            .btn-small {
              width: 145px;
              font-size: 13px;
              font-weight: bold;
              letter-spacing: -0.1px;
            }
          }
        }
      }

      &__modal {
        position: fixed;
        top: 40px;
        right: 283px;
        width: 800px;
        height: 688px;
        border-radius: 8px;
        border: solid 1px var(--pale-grey);
        background-color: #ffffff;
        box-shadow:0 0 0 5000px rgba(0, 0, 0, 0.75);

        &__buttons-up {
          display: flex;
          height: 40px;
          align-items: center;
          padding-left: 20px;
        }

        &__title {
          height: 40px;
          padding-left: 20px;
          padding-top: 10px;
          font-size: 18px;
          font-weight: bold;
          line-height: 1.22;
          letter-spacing: -0.2px;
        }

        &__content {
          height: 528px;

          &__left {
            &__campaign-detail {
              &__title {
                font-family: CoreSansC-45;
                font-size: 10px;
                line-height: 1.4;
                letter-spacing: 0.3px;
                padding-left: 20px;
              }
            }
          }
        }

        &__buttons-down {
          height: 80px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-left: 20px;
          padding-right: 20px;
        }
      }
    }

    &__channel{
      right: 60px;
      display: flex;
      align-items: center;
      
      &__icon{
        z-index: 4;
        width: 35px;
        height: 35px;
        border-radius: 20px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px var(--pale-grey);
        background-color: #ffffff;
        cursor: pointer;
        
        .badge {
          top: -4px;
          position: absolute;
          min-width: 18px;
          height: 18px;
          right: -6px;
          top: -8px;
          
          &.small {
            line-height: 0.9;
            padding-left: 5px;
          }
          
          &.big {
            line-height: 1;
            font-size: 10px;
          }
        }
      }

      &__list-campaign {
        position: fixed;
        top: 58px;
        right: 22px;
        width: 320px;
        height: 400px;
        border-radius: 8px;
        box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px var(--pale-grey);
        background-color: #ffffff;

        &__title{
          padding-top: 23px;
          padding-left: 16px;
          margin-bottom: 8px;
          display: flex;

          span{
            margin-right: 4px;
            i{
              font-size: 14px;
            }
          }
        }

        &__wrapper{
          padding: 0 16px;
          overflow-x: hidden;
          height: 330px;

          &__content {
            margin-top: 24px;
            padding: 0 16px;

            &__my-campaign , &__others-campaign{
              .row-content {
                display: flex;
                justify-content: space-between;
                width: 290px;
                padding: 10px 18px 10px 0px;

                &__left {
                  flex-grow: 5;
                  width: 70%;
                  cursor: pointer;

                  &__name {
                    font-size: 13px;
                  }

                  &__total {
                    font-size: 13px;
                    color: #878787;
                  }
                }

                &__right {
                  // flex-grow: 5;
                  // padding: 20px 0px 0 63px;
                  // width: 0%;

                  .delete:hover {
                    cursor: pointer;
                  }
                }
              }

              .row:hover {
                background-color: #f5f5fa;
              }
            }
          }
        }
      }
    }

    img {
      width: 16px;
      height: 16px;
      margin-top: 9.5px;
      margin-left: 10px;
    }
  }

  .disabled{
    opacity: 0.7;
    cursor: no-drop;
  }

  .reset{
    &__wrapper{
      &__buttons{
        display: flex;
        justify-content: space-between;
        padding-top: 20px;

        .btn-block {
          width: 45%;
        }
      }
    }
  }

  .button_section {
    height: 30px;
  }

  .modal__content.undefined.no-title {
    width: 336px;
    height: 240px;
    overflow: hidden;
    top: 20%;

    .btn-no-title {
      padding-top: 15px;
    }
  }

  .medium-title {
    font-size: 18px;
  }

  .subhead-reset {
    font-size: 14px;
    color: black;
    padding-top: 5px;
  }
  
  .subhead-mycampaign {
    font-size: 13px;
    width: 184px;
    padding-top: 16px;
  }

  .subhead-otherscampaign {
    font-size: 13px;
    width: 185px;
    padding-top: 16px;
  }

  .reset__wrapper {
    width: 288px;
    margin-left: -19px;

    &__buttons {
      padding-top: 39px;

      .primary {
        width: 63px;
        height: 40px;
        font-size: 13px;
        font-weight: 700;
        border-radius: 8px;
      }
      .secondary {
        width: 99px;
        height: 40px;
        font-size: 13px;
        font-weight: 700;
        border-radius: 8px;
      }
    }
  }
</style>
